module.exports = __webpack_public_path__ + "static/media/00.c70c866a.jpg";